import { render } from "./calendarBody.vue?vue&type=template&id=3ac8e74f&scoped=true"
import script from "./calendarBody.vue?vue&type=script&lang=js"
export * from "./calendarBody.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3ac8e74f"

export default script